import { BaseText, type BaseTextProps } from "~/components/layout/text/BaseText";

export const FieldHint = ({
    size = "xs",
    colour = "tertiary",
    weight = "semibold",
    children,
    ...textProps
}: BaseTextProps) => {
    return (
        <BaseText {...textProps} size={size} colour={colour} weight={weight}>
            {children}
        </BaseText>
    );
};
